<template>
  <CHeader fixed with-subheader light class="top-header">
    <CHeaderBrand class="mr-auto pl-4 d-lg-none" to="/">
<!--      <CIcon name="logo" height="48" alt="Logo"/>-->
      <img src="@/assets/black-condensen-white-bg.png" class="ml-2" height="25" alt="black-condensen-white-bg.png"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <span class="text-white mr-3">Hello, {{user.name | capitalize}}</span>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  computed:{
    unreadMessagesCounter(){
      let unread_notification_counter = 0
      this.notifications.forEach(notification =>{
        if (notification.type == "message" && notification.read_at == null || notification.read_at == ''){
          unread_notification_counter +=1
        }
      })
      return unread_notification_counter
    },
    unreadNotificationsCounter(){
      let unread_notification_counter = 0
      this.notifications.forEach(notification =>{
        if (notification.type != "message" && notification.read_at == null || notification.read_at == ''){
          unread_notification_counter +=1
        }
      })
      return unread_notification_counter
    },
    randomNotifications(){
      let notifications = []
      this.notifications.forEach(notification =>{
        if (notification.type != 'message'){
          notifications.push(notification)
        }
      })
      return notifications
    },
    messagesNotifications(){
      let messages = []
      this.notifications.forEach(message => {
        if (message.type == 'message'){
          messages.push(message)
        }
      })
      return messages
    },
    user(){
      return this.$store.getters.user
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  components: {
    TheHeaderDropdownAccnt,
  },
  data(){
    return{
      notifications: [],
      enviornment : process.env.VUE_APP_SOCKET_ENV,
    }
  },
}
</script>
<style scoped>
  .top-header{
    background-color: #424242;
  }
</style>